var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHsa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".HSA_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "HSA_svg__a",
    d: "M9.071 19.071H6.929a2 2 0 01-2-2v-1.314a2 2 0 00-.586-1.414l-.929-.929a2 2 0 010-2.828l.929-.929a2 2 0 00.586-1.414V6.929a2 2 0 012-2h1.314a2 2 0 001.414-.586l.929-.929a2 2 0 012.828 0l.929.929a2 2 0 001.414.586h1.314a2 2 0 012 2v1.314a2 2 0 00.586 1.414l.929.929a2 2 0 010 2.828l-.929.929a2 2 0 00-.586 1.414v1.314a2 2 0 01-2 2h-1.314a2 2 0 00-1.414.586l-.929.929a2 2 0 01-2.828 0l-1.515-1.515z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "HSA_svg__a",
    d: "M13.643 8.971A2.493 2.493 0 0116 11.51c0 2.485-3.929 4.52-4 4.52S8 14 8 11.51a2.493 2.493 0 012.357-2.539A2.116 2.116 0 0112 9.726a2.116 2.116 0 011.643-.755z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgHsa;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/HSA.svg
// module id = 7881
// module chunks = 13